const lunch = [
    {
        id: 1,
        name: 'Prego no prato',
        description: 'Bife, batata frita, salada',
        price: '7.000'
    },
    {
        id: 2,
        name: 'Bife à portuguesa',
        description: 'Bife, ovo estralado, molho atomatado com pimenta, cenoura, batatas fritas, arroz',
        price: '12.000'
    },
    {
        id: 3,
        name: 'Picanha',
        description: 'Carne de vaca, banana panada, batatas fritas, feijão preto, arroz',
        price: '15.000'
    }
];

export default lunch;